var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Toggle } from '../Toggle/index.js';
import { FormControlMeta } from './FormControlMeta.js';
export const FormControlToggle = props => {
    const { name, label, helperText, error, invalid, hidden, checked, onChange, className } = props, rest = __rest(props, ["name", "label", "helperText", "error", "invalid", "hidden", "checked", "onChange", "className"]);
    return (React.createElement("div", { hidden: hidden, className: className },
        React.createElement(Toggle, Object.assign({}, rest, { checked: checked, onChange: onChange, name: name, title: label })),
        (!!helperText || !!error) && (React.createElement("div", { className: "-mt-2" },
            React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid }))))));
};
//# sourceMappingURL=FormControlToggle.js.map